import i18n from "i18next";
import HttpBackend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

export const SUPPORTED_LOCALES = ["sr"] as const;
export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];

/**
 * i18n bootstrap. Locales live under /public/locales/<lang>/<namespace>.json
 * and are lazy-loaded via i18next-http-backend.
 *
 * CMMS ships a single locale (sr, latin script) — the i18next pattern is kept
 * so screens read the same as the portal (`t("key", "fallback")`), but there is
 * no language detector and no per-user locale: the language is pinned to "sr".
 */
void i18n
  .use(HttpBackend)
  .use(initReactI18next)
  .init({
    lng: "sr",
    fallbackLng: "sr",
    supportedLngs: SUPPORTED_LOCALES as readonly string[] as string[],
    load: "languageOnly",
    ns: ["common", "auth"],
    defaultNS: "common",
    // Keys are stored FLAT with literal dots (e.g. "admin.users.title"). Disabling
    // the key separator makes every dotted key a literal lookup, so a key used both
    // as a label and as a parent can coexist without i18next building an object at
    // the shared path. Locale JSON is fully flattened to match.
    keySeparator: false,
    interpolation: {
      escapeValue: false, // React already escapes
    },
    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json",
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;
